import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { makeTransparentColor } from 'assets/styles/transparentColor';

import ButtonBase from './ButtonBase';

const WhiteButton = styled(ButtonBase)`
  border: 1px solid ${theme.color.red};
  background-color: ${theme.color.white};
  color: ${theme.color.red};

  &:hover {
    background-color: ${theme.color.red};
    color: ${theme.color.white};
    box-shadow: 0 0 10px ${makeTransparentColor(theme.color.red, 0.7)};
  }

  &:disabled {
    background-color: ${theme.color.disabled};
    box-shadow: none;
  }
`;

export default WhiteButton;
